// extracted by mini-css-extract-plugin
module.exports = {"timeline":"_3N6350uOx0bwKrc4IGfT","event":"_1WqHvD0pAv6vKpcdlhkl","minute-of-match":"_29bLAc3ZWkdZG7Dcv883"};